<template>
<div class='stats'>
  <div class='nav'>
    <el-menu class='theme-primary' :default-active="$route.path" router>
      <el-menu-item :index="`/projects/${id}/stats`">
        {{$t('actions.project.stats.data')}}
      </el-menu-item>
      <el-menu-item :index="`/projects/${id}/stats/form`" v-if="project.has_form">
        {{$t('actions.project.stats.form')}}
      </el-menu-item>
    </el-menu>
  </div>
  <router-view class="sub-stats"></router-view>
</div>
</template>

<style lang='scss' scoped>
.stats {
    position: relative;
    background-color: transparent !important;
    padding: 0 !important;
    text-align: left!important;
    $nav-width: 240px;

    .nav {
        float: left;
        position: absolute;
        width: $nav-width;
        min-height: 480px;
        top: 0;
        background-color: $color-white-base;
        padding-top: $padding-base;
        box-shadow: $box-shadow-base;
    }

    .sub-stats {
        overflow: hidden;
        padding-left: $nav-width + $margin-base;
        min-height: 600px;
    }
}
</style>

<script>
export default {
  computed: {
    id() {
      return this.$route.params.id
    },
    project() {
      return this.$store.state.project.items[this.id]
    }
  }

}
</script>



// WEBPACK FOOTER //
// index.vue?2e691be0